import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AppComponent } from './components/app.component';
import { APP_DECLARATIONS } from './app.declarations';
import { APP_PROVIDERS } from "./app.providers";
import { AppRoutes } from './app.routes';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: APP_DECLARATIONS,
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    RouterModule.forRoot(AppRoutes),
  ],
  providers: [...APP_PROVIDERS, provideHttpClient(withInterceptorsFromDi())],
  bootstrap: [AppComponent]
})
export class AppModule { }
